import { createAction } from 'redux-actions';
import {
  UPDATE_CURRENT_ITEM_QUANTITY,
  COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY,
  INITIATE_ADD_ITEM_TO_BUNDLE,
  START_REMOVE_ITEM_FROM_BUNDLE,
  ADD_ORDER_SUMMARY,
  ADD_ITEM_TO_ORDER_SUMMARY_FAILED,
  SET_LINE_ITEM_PRICE,
  REMOVE_ITEM_IN_BUNDLE_FROM_STORE,
  CREATE_PURCHASED_LOGO,
  CREATE_PURCHASED_LOGO_FAILED,
  ADD_LIQUIDPIXEL_LOGO_FAILS,
  CREATE_ORDER_LINEITEM_LOGO,
  ADD_PREV_LOGO_TO_NEWLINEITEM,
  ADD_LIQUIDPIXEL_UPDATED_LOGO,
  COMPLETE_LIQUIDPIXEL_UPDATED_LOGO,
  LINE_ITEM_NOT_TO_BE_REMOVED,
  ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED,
  CREATE_ORDER_LINEITEM_LOGO_FAILED,
  SKU_EXISTS,
} from './actionTypes';

export const updateCurrentItemQuantity = newQuantity => (
  createAction(
    UPDATE_CURRENT_ITEM_QUANTITY,
    () => ({ newQuantity }),
  )
)(newQuantity);

export const initiateAddItemToBundle = ({ id, updatedCurrentselection }) => (
  createAction(
    INITIATE_ADD_ITEM_TO_BUNDLE,
    () => ({ id, updatedCurrentselection }),
  )
)(id, updatedCurrentselection);

export const createOrderLineItemLogo = () => (
  createAction(
    CREATE_ORDER_LINEITEM_LOGO,
    () => ({ }),
  )
)();

export const createOrderLineItemLogoFailed = (error) => (
  createAction(
    CREATE_ORDER_LINEITEM_LOGO_FAILED,
    () => ({ error }),
  )
)(error);

export const addPrevLogoToNewLineFailed = (error) => ({
  type: ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED,
  error,
})

export const addLiquidPixelLogoFailed = (error) => ({
  type: ADD_LIQUIDPIXEL_LOGO_FAILS,
  error
});

export const addLiquidPixelUpdatedLogo = (payload) => ({
  type: ADD_LIQUIDPIXEL_UPDATED_LOGO,
  payload,
});

export const completeLiquidPixelUpdatedLogo = returnUrls => (
  createAction(
    COMPLETE_LIQUIDPIXEL_UPDATED_LOGO,
    () => ({ returnUrls }),
  )
)(returnUrls);

export const createPurchasedLogo = () => (
  createAction(
    CREATE_PURCHASED_LOGO,
    () => ({ }),
  )
)();

export const createPurchasedLogoFailed = (error) => (
  createAction(
    CREATE_PURCHASED_LOGO_FAILED,
    () => ({error}),
  )
)(error);

export const addPrevLogoToNewLineItem = (payload) => ({
    type: ADD_PREV_LOGO_TO_NEWLINEITEM,
    payload,
});

export const addOrderSummary = () => (
  createAction(
    ADD_ORDER_SUMMARY,
    () => ({ }),
  )
)();

export const lineItemNotToBeRemoved = ({ truthy }) => (
  createAction(
    LINE_ITEM_NOT_TO_BE_REMOVED,
    () => ({ truthy }),
  )
)(truthy);



export const startRemoveItemFromBundle = ({ id }) => (
  createAction(
    START_REMOVE_ITEM_FROM_BUNDLE,
    () => ({ id }),
  )
)(id);

export const removeItemInBundleFromStore = ({ id }) => (
  createAction(
    REMOVE_ITEM_IN_BUNDLE_FROM_STORE,
    () => ({ id }),
  )
)(id);

export const completeAddItemToBundle = newItem => (
  createAction(
    COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY,
    () => ({ newItem }),
  )
)(newItem);

export const addItemToOrderSummaryFailed = () => (
  createAction(
    ADD_ITEM_TO_ORDER_SUMMARY_FAILED,
    () => ({ }),
  )
)();

export const setLineItemPrice = payload => (
  createAction(
    SET_LINE_ITEM_PRICE,
    () => (payload),
  )
)(payload);

export const skuExists = (data) => (
  createAction(
    SKU_EXISTS,
    () => ({ data}),
  )
)();
